import { Injectable } from '@angular/core';

import { LabService } from '../../../services/lab.service';

@Injectable()
export class PatientRequestStatusService extends LabService {

    public modelPath = 'lab/request_status/update_status_based_module';
}
